export default __webpack_public_path__ + "static/media/eat-alot.4ffa1dde.gif";